var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "yxt-drawer",
    {
      attrs: {
        title: _vm.$t("pc_setup"),
        visible: _vm.visible,
        size: "480px",
        direction: "rtl",
      },
      on: { close: _vm.handleCancel },
    },
    [
      _c(
        "yxt-form",
        {
          ref: "formRef",
          staticClass: "form-box",
          attrs: {
            model: _vm.formData,
            "is-need-require": "",
            "is-need-tooltip": "",
            "label-width": "110px",
          },
        },
        [
          _c(
            "yxt-form-item",
            { attrs: { label: _vm.$t("pc_label_no_audit"), prop: "roles" } },
            [
              _c("yxt-select", {
                attrs: {
                  multiple: "",
                  placeholder: _vm.$t("pc_select_placeholder"),
                  "icon-name": "more",
                  "hidden-option": "",
                  "collapse-tags": "",
                  "value-key": "id",
                  "prop-label": "name",
                },
                on: {
                  "visible-change": function ($event) {
                    _vm.dialogVisible = true
                  },
                },
                scopedSlots: _vm._u([
                  {
                    key: "tag",
                    fn: function (ref) {
                      var data = ref.data
                      return [
                        _c("yxtbiz-user-name", {
                          attrs: { name: data.currentLabel },
                        }),
                      ]
                    },
                  },
                ]),
                model: {
                  value: _vm.formData.roles,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "roles", $$v)
                  },
                  expression: "formData.roles",
                },
              }),
              _c("div", { staticClass: "tip color-gray-7" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("pc_tip_skip_audit")) +
                    "\n      "
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "yxt-button",
            { attrs: { plain: "" }, on: { click: _vm.handleCancel } },
            [_vm._v(_vm._s(_vm.$t("pc_cancel_mini")))]
          ),
          _c(
            "yxt-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleOk } },
            [_vm._v(_vm._s(_vm.$t("pc_ok_mini")))]
          ),
        ],
        1
      ),
      _c(
        "yxt-drawer",
        {
          ref: "selectDrawer",
          attrs: {
            "header-border": false,
            "destroy-on-close": true,
            size: "960px",
            visible: _vm.dialogVisible,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("yxtbiz-range-selector", {
            ref: "selector",
            attrs: {
              model: "array",
              selected: _vm.formData.roles,
              tabs: ["persons", "advance", "userGroup"],
              "function-code": _vm.functionCode,
              "data-permission-code": _vm.dataPermissionCode,
            },
            on: {
              change: function ($event) {
                _vm.users = $event
              },
            },
          }),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "yxt-button",
                {
                  attrs: { plain: "" },
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("pc_cancel")))]
              ),
              _c(
                "yxt-button",
                { attrs: { type: "primary" }, on: { click: _vm.selectUserOk } },
                [_vm._v(_vm._s(_vm.$t("pc_ok")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }